import React from 'react';
import { ToggleWrapper } from './ToggleItem.styles';
import { TextV2, TextV2Props } from '@withjoy/joykit';
import classNames from 'classnames';

export interface ToggleItemProps {
  label: string;
  value: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  isActive?: boolean;
  isDisabled?: boolean;
  isMobile?: boolean;
  minWidth?: string;
  textProps?: TextV2Props;
}

const ToggleItem: React.SFC<ToggleItemProps> = ({ onClick, isActive, value, isMobile, minWidth, textProps = {}, isDisabled }) => {
  return (
    <ToggleWrapper
      as="a"
      isMobile={isMobile}
      onClick={isDisabled ? undefined : onClick}
      minWidth={minWidth}
      className={classNames({ active: isActive, disabled: isDisabled })}
    >
      <TextV2
        typographyVariant="hed1"
        color="currentColor"
        {...textProps}
      >
        {value}
      </TextV2>
    </ToggleWrapper>
  );
};

export { ToggleItem };
